module.exports = __webpack_public_path__ + "media/images/icon-cog-c88cf3392b80ab0143e0905249508691.svg";